import { ITableButtonProps } from '@components/common/UTable/UTable';

import { securityConfig } from '@/shared/security/hasPermission';

interface ExtraButtonConfigProps {
  onDownload: () => void;
  isDownloading: boolean;
  security: securityConfig;
  disabled: boolean;
}
export const extraButtonConfig = ({
  onDownload,
  isDownloading,
  security,
  disabled,
}: ExtraButtonConfigProps): ITableButtonProps[] => {
  return [
    {
      text: 'Экспорт в Excel',
      type: 'primary',
      action: onDownload,
      loading: isDownloading,
      disabled: disabled || isDownloading,
      security,
    },
  ];
};
